var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"progress-updates page p-5"},[_vm._m(0),_c('router-view',{staticClass:"progress-updates__view"})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"page__header"},[_c('h1',{staticClass:"page__title"},[_vm._v(" Progress Updates ")])])
}]

export { render, staticRenderFns }